import React from 'react';
import { motion } from 'framer-motion';
import { marqueeText } from '../mockData';

const Marquee = () => {
  return (
    <div className="relative overflow-hidden bg-white border-y border-gray-100 py-8" data-testid="marquee-section">
      <div className="flex whitespace-nowrap">
        {/* First copy */}
        <motion.div
          animate={{ x: ['0%', '-100%'] }}
          transition={{
            duration: 40,
            repeat: Infinity,
            ease: 'linear',
          }}
          className="flex items-center px-4"
        >
          {Array(3)
            .fill(marqueeText)
            .map((text, index) => (
              <span
                key={`first-${index}`}
                className="text-2xl md:text-3xl font-semibold text-gray-300 tracking-tight"
              >
                {text}
              </span>
            ))}
        </motion.div>
        {/* Second copy for seamless loop */}
        <motion.div
          animate={{ x: ['0%', '-100%'] }}
          transition={{
            duration: 40,
            repeat: Infinity,
            ease: 'linear',
          }}
          className="flex items-center px-4"
        >
          {Array(3)
            .fill(marqueeText)
            .map((text, index) => (
              <span
                key={`second-${index}`}
                className="text-2xl md:text-3xl font-semibold text-gray-300 tracking-tight"
              >
                {text}
              </span>
            ))}
        </motion.div>
      </div>
    </div>
  );
};

export default Marquee;
